var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { Button } from 'Components.Form';
import { FormattedMessage } from 'Intl';
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 1rem 0;\n  display: flex;\n  justify-content: center;\n"], ["\n  padding: 1rem 0;\n  display: flex;\n  justify-content: center;\n"])));
var ContinueProcess = function (_a) {
    var _b = _a.label, label = _b === void 0 ? undefined : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.buttonId, buttonId = _d === void 0 ? undefined : _d, props = __rest(_a, ["label", "disabled", "buttonId"]);
    return (React.createElement(Container, null,
        React.createElement(Button, { id: "".concat(buttonId, "_saveAndContinue_button"), success: true, taller: true, disabled: disabled, onClick: props.onClick }, label || React.createElement(FormattedMessage, { id: 'common.saveAndContinue' }))));
};
export default ContinueProcess;
var templateObject_1;
